import MockAdapter from "axios-mock-adapter";

import { api } from "@/lib/api-client";

import type * as MockAdapterType from "axios-mock-adapter";

let instance: MockAdapterType;

function createInstance() {
  return new MockAdapter(api, {
    delayResponse: 500,
    onNoMatch: "passthrough",
  });
}

export const AxiosMock = {
  getInstance() {
    if (instance === undefined) {
      instance = createInstance();
    }
    return instance;
  },
};
